import React, { useState } from 'react';
import { useMutation } from 'react-query';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiEditOutlinedIcon from '@material-ui/icons/EditOutlined';
import MuiBlockIcon from '@material-ui/icons/Block';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import { WithTooltip } from 'utils/wrappers';
import EditISRC from './edit-ISRC';
import AuthAxios from 'utils/authAxios';
import { dataApiUrl } from 'utils/url';

const DataApiUrl = dataApiUrl();

function TrackTableRow({ row, isDelivered, rowChanged }) {
  const [isEditingISRC, setIsEditingISRC] = useState(false);

  //TODO move to a dedicated data-client
  const { mutate: patchTrackMutation } = useMutation(
    (options = {}) => {
      const { trackId, patchObject } = options;
      return AuthAxios.patch(`${DataApiUrl}/admin/tracks/${trackId}`, patchObject);
    },
    {
      onSuccess: () => {
        setIsEditingISRC(false);
        rowChanged();
      },
      onError: error => {
        alert(error.response?.data?.error);
      },
    }
  );

  const getAllArtistRoles = ({ trackParties = [] }) =>
    trackParties
      .filter(party => party.asset_track_party_type.toLowerCase() === 'artist')
      .reduce((artistRolesString, currentArtist) => {
        return [...artistRolesString, currentArtist.party.full_name + ' ' + currentArtist.roles];
      }, []);

  return (
    <MuiTableRow key={row.id}>
      <MuiTableCell style={{ width: '5%' }} component="th" scope="row">
        {row.id}
      </MuiTableCell>
      <MuiTableCell style={{ width: '5%' }}>{row.sequence}</MuiTableCell>
      <MuiTableCell style={{ width: '15%' }}>
        {!isEditingISRC ? (
          row.isrc_code || '—'
        ) : (
          <EditISRC
            trackId={row.id}
            isrc={row.isrc_code}
            onSave={({ trackId, isrc }) => patchTrackMutation({ trackId, patchObject: { isrc_code: isrc } })}
          />
        )}
        {!isDelivered ? (
          <WithTooltip>
            <MuiIconButton onClick={() => setIsEditingISRC(!isEditingISRC)}>
              <MuiEditOutlinedIcon />
            </MuiIconButton>
          </WithTooltip>
        ) : null}
      </MuiTableCell>
      <MuiTableCell style={{ width: '20%' }}>{row.title}</MuiTableCell>
      <MuiTableCell style={{ width: '20%' }}>
        <ul style={{ listStyleType: 'none', padding: '0' }}>
          {getAllArtistRoles(row).map((artistsString, idx) => {
            return <li key={`${idx}-${artistsString}`}>{artistsString}</li>;
          })}
        </ul>
      </MuiTableCell>
      <MuiTableCell style={{ width: '5%' }}>
        <WithTooltip tooltip={row.block_royalties ? 'Unblock Royalties' : 'Block Royalties'}>
          <MuiIconButton
            onClick={() =>
              patchTrackMutation({ trackId: row.id, patchObject: { block_royalties: !row.block_royalties } })
            }>
            <MuiBlockIcon color={row.block_royalties ? 'error' : 'action'} />
          </MuiIconButton>
        </WithTooltip>
      </MuiTableCell>
    </MuiTableRow>
  );
}

export default TrackTableRow;
